(function () {
  var GALLERY = '#ProductMediaImages .images-wrapper';

  function refresh() {
    var lazyload = window.ORW && window.ORW.lazyload;
    if (!lazyload) return false;
    lazyload.update();
    return true;
  }

  function start() {
    var gallery = document.querySelector(GALLERY);

    if (gallery && 'MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = requestAnimationFrame(function () {
          pending = null;
          refresh();
        });
      }).observe(gallery, { childList: true, subtree: true });
    }

    if (!refresh()) {
      var tries = 0;
      var timer = setInterval(function () {
        if (refresh() || ++tries > 40) clearInterval(timer);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
